export const UPLOAD_CONFIGS = {
  community: {
    previewField: 'communityPreview',
    fileField: 'selectedCommunityFile',
    label: 'Custom Card Image. 400 x 400px.',
    displayType: 'image',
  },
  tag: {
    previewField: 'preview',
    fileField: 'selectedFile',
    label: 'Custom Image. Recommended size: 1400 x 600px.',
    displayType: 'image',
  },
  'set-video': {
    previewField: 'previewVideo',
    fileField: 'setVideoFile',
    label: 'Header Video (optional). Recommended size: 2200px x 920px.',
    displayType: 'video',
  },
  'set-logo': {
    previewField: 'previewLogo',
    fileField: 'setLogoFile',
    label: 'Header Logo (optional). Max height: 120px',
    displayType: 'image',
  },
  section: {
    previewField: 'previewSection',
    fileField: 'sectionFile',
    label: '',
    displayType: 'image',
  },
  'optional-media': {
    previewField: 'previewOptionalMedia',
    fileField: 'selectedOptionalMediaFile',
    label: 'Optional image or video. Recommended size: 1200px x 675px.',
    displayType: 'image-or-video',
  },
};
